import React from "react";
import PropTypes from "prop-types";

import { Container, Title, Contents } from "./styled";

const ContentBlock = ({ title, contents }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Contents dangerouslySetInnerHTML={{ __html: contents}} />
    </Container>
  );
};

ContentBlock.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.string,
};

export default ContentBlock;
